/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMBED : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	embed: {
		width: '100%',
		height: pxToEm(350),
		color: theme.color.light.light.swatch,
		padding: replacePXinStringWithEM(`0 20px`),
		position: 'relative',
		'&.editable-false': {
			// pointerEvents: 'none', // remove ability to select elements within embed if we don't want it editable
									  // pointerEvents: 'none' is moved down to a content level to allow onClick events on non-editable embeds
			'& .editorelement, .imageindicator': {
				display: 'none' // remove all editing elements
			}
		},
		'&.editable-true': {
			'& .answer .text2 .desc .icon': { 
				background: 'none !important' // done because radio button for correct answer choice is over top
			},
			'& .answerset.text1 .answer': { 
				display: 'flex',
				justifyContent: 'flex-end',
				'& > .text1': {
					width: '95%',
					marginLeft: '0',
					marginRight: '0'
				}
			},
			'&.in-content': {
				'& .answerset.image1 .answer': {
					'& .graphic': {
						fontSize: '140%'
					},
					'& .desc .text': {
						fontSize: pxToEm(16)
					}
				},
				'& .answerset.text1 .answer': { 
					'& > .text1': {
						width: '97%'
					},
					'& .correct.text1': {
						left: '-5.3%'
					},
				},
				'& .correct.text2': {
					left: '-2%'
				}
			}
		},
		'& .structureinner': {
			width: '100%',
			height: '100%',
			position: 'absolute',
			top: '0'
		},
		'& .header': {
			textAlign: 'right',
			height: pxToEm(45),
			position: 'relative',
			// zIndex: '3', removed so we can click empty space for bg selector (add zindex to partner logo instead)
			'& .structureinner': {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-end'
			}
		},
		'& .body': {
			textAlign: 'center',
			height: replacePXinStringWithEM('calc(100% - 45px - 40px)'),
			position: 'relative',
			// zIndex: '3', removed so we can click empty space for bg selector (instead on individual elements)
		}
	}
});